module.exports = __webpack_public_path__ + "fe3c1fe94b42920d1a407028640d89ad.svg";